<p-drawer
    #mobileDrawerRef
    [modal]="true"
    maskStyle="background-color:transparent !important"
    [dismissible]="true"
    [visible]="currentContent != null"
    position="bottom"
    [autoZIndex]="false"
    styleClass="!shadow-none !shadow-top-lift rounded-t-2xl z-[900]"
    style="height: 95% !important; max-height: 95% !important; justify-content: flex-start"
    [appendTo]="navRef">
    <ng-template #headless>
        <div
            class="w-full h-[25px] flex justify-center items-end cursor-grab touch-none"
            [ngClass]="{ 'mb-[20px]': !showBackButton }"
            (touchstart)="onTouchStart($event)"
            (touchmove)="onTouchMove($event)"
            (touchend)="onTouchEnd($event)"
            (touchcancel)="onTouchEnd($event)"
            (click)="clickDrawerHandle($event)">
            <div class="w-10 h-1 bg-[#8B8888] rounded"></div>
        </div>

        @if (showBackButton) {
            <div
                class="ml-4 mb-2"
                (touchstart)="onTouchStart($event)"
                (touchmove)="onTouchMove($event)"
                (touchend)="onTouchEnd($event)"
                (touchcancel)="onTouchEnd($event)">
                <p-button
                    [buttonProps]="{ autofocus: false }"
                    [ariaLabel]="backButtonLabel"
                    (click)="clickBackButton($event)"
                    size="small"
                    [outlined]="false"
                    severity="secondary"
                    icon="pi pi-arrow-left" />
            </div>
        }

        <div
            class="flex flex-col rounded-t-2xl overflow-auto h-full w-full"
            (touchstart)="onTouchStart($event)"
            (touchmove)="onTouchMove($event)"
            (touchend)="onTouchEnd($event)"
            (touchcancel)="onTouchEnd($event)">
            @if (currentContent) {
                <ng-container
                    *ngComponentOutlet="
                        currentContent.component;
                        inputs: currentContent.context
                    "></ng-container>
            }
        </div>

        <!-- Account for upcmoming session banner -->
        @if (upcomingSessionsService.visible()) {
            <div class="h-12 min-h-12"></div>
        }
        <!-- Account for navigation bar -->
        <div class="h-[53px] min-h-[53px]"></div>
    </ng-template>
</p-drawer>
